import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: 'sso-required',
    loadComponent: () => import('./pages/sso-required/sso-required.component').then((m) => m.SsoRequiredComponent),
  },
  {
    path: '',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [authGuard],
  },
  {
    path: 'inventory',
    loadComponent: () => import('./pages/inventory/inventory.component').then((m) => m.InventoryComponent),
    canActivate: [authGuard],
  },
  {
    path: 'packs',
    loadComponent: () => import('./pages/packs/packs.component').then((m) => m.PacksComponent),
    canActivate: [authGuard],
  },
  {
    path: 'packs/reveal/:openingId',
    loadComponent: () =>
      import('./pages/packs/pack-reveal/pack-reveal.component').then((m) => m.PackRevealComponent),
    canActivate: [authGuard],
  },
  {
    path: 'cards',
    loadComponent: () => import('./pages/card-database/card-database.component').then((m) => m.CardDatabaseComponent),
    canActivate: [authGuard],
  },
  {
    path: 'decks',
    loadComponent: () => import('./pages/decks/decks.component').then((m) => m.DecksComponent),
    canActivate: [authGuard],
  },
  {
    path: 'decks/:id',
    loadComponent: () => import('./pages/decks/deck-editor/deck-editor.component').then((m) => m.DeckEditorComponent),
    canActivate: [authGuard],
  },
  {
    path: 'matchrooms',
    loadComponent: () => import('./pages/matchrooms/matchrooms.component').then((m) => m.MatchroomsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'matchrooms/:id',
    loadComponent: () =>
      import('./pages/matchrooms/matchroom-detail/matchroom-detail.component').then((m) => m.MatchroomDetailComponent),
    canActivate: [authGuard],
  },
  {
    path: 'matchrooms/:id/match',
    loadComponent: () => import('./pages/matchrooms/match-page/match-page.component').then((m) => m.MatchPageComponent),
    canActivate: [authGuard],
  },
  {
    path: 'shop',
    loadComponent: () => import('./pages/shop/shop.component').then((m) => m.ShopComponent),
    canActivate: [authGuard],
  },
  {
    path: 'coins',
    loadComponent: () => import('./pages/coin-shop/coin-shop.component').then((m) => m.CoinShopComponent),
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/shell/admin-shell.component').then((m) => m.AdminShellComponent),
    canActivate: [authGuard, adminGuard],
    children: [
      {
        path: 'cards',
        loadComponent: () => import('./pages/admin/cards/admin-cards.component').then((m) => m.AdminCardsComponent),
      },
      {
        path: 'packs',
        loadComponent: () => import('./pages/admin/packs/admin-packs.component').then((m) => m.AdminPacksComponent),
      },
      { path: '', redirectTo: 'cards', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
